import { render, staticRenderFns } from "./BienDetailsCaracteristiquesItem.vue?vue&type=template&id=fb47422c"
import script from "./BienDetailsCaracteristiquesItem.vue?vue&type=script&lang=js"
export * from "./BienDetailsCaracteristiquesItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports